import React, { Component } from 'react';

import { Survey } from '../components/survey';
import { Realization } from '../components/realization';
import { About } from '../components/about';

class Home extends Component {
  render() {
    return (
      <>
        <Survey />

        <Realization />
        <About />
      </>
    )
  }
}

export default Home;
